import React from 'react'
import PropTypes from 'prop-types'
import GiftGroup from '../GiftGroup/GiftGroupContainer'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

const GiftGroups = ({ selectableGifts, onClose, mediaQuery, isLoading }) => {
  const isDesktop = mediaQuery({
    phone: false,
    tablet: false,
    desktop: true,
  })

  const giftGroups = selectableGifts.map((giftGroup, index) => {
    return <GiftGroup key={index} giftGroup={giftGroup} />
  })

  return (
    <div>
      <ModalTitle id="cartGiftTitle" />
      <div className="GiftGroups component">{giftGroups}</div>
      <div className="flex justify-end mt5 mt7-l">
        <Button
          id="closeGiftGroups"
          variation="primary"
          onClick={onClose}
          isLoading={isLoading}
          block={!isDesktop}
        >
          <FormattedMessage id="noteConfirm" />
        </Button>
      </div>
    </div>
  )
}

GiftGroups.defaultProps = {
  isLoading: false,
}

GiftGroups.propTypes = {
  selectableGifts: PropTypes.array,
  onClose: PropTypes.func,
  isLoading: PropTypes.bool,
  mediaQuery: PropTypes.func.isRequired,
}

export default withMediaQuery(GiftGroups)
